import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { Grid, Box, TextField, Divider } from '@mui/material';
import { IPrompt, scopeType } from 'wisestep-api';
import {
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  WsElementWithPopOver,
  WsIconMoreVer,
  WsLogo,
  WsActiveIconAndText,
  WsDisableIconAndText,
} from 'wisestep-base';

import { warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import { defaultTitleHeading } from '../utils/PromptHelper';
export interface IPromptList {
  data: IPrompt;
  promptData: IPrompt[];
  index: number;
  defaultNumber: number;
  onSetPromptdata: (value: IPrompt[]) => void;
  onSelecetdPrompt: (value: IPrompt) => void;
  onOpenPromptDialogForEdit: (value: boolean) => void;
}

const PromptList = ({
  data,
  promptData,
  index,
  defaultNumber,
  onSetPromptdata,
  onSelecetdPrompt,
  onOpenPromptDialogForEdit,
}: IPromptList) => {
  const setNotification = useNotificationStore((state) => state.setNotification);

  const onActivatePrompt = () => {
    if (data.active) {
      setNotification(warning('Prompt is already activated'));
    } else {
      const updatedPromptData = updateActiveStatus(promptData, data.promptTitle);
      onSetPromptdata(updatedPromptData);
    }
  };

  const updateActiveStatus = (promptData, targetPromptTitle) => {
    return promptData.map((prompt) => {
      if (prompt.promptTitle === targetPromptTitle) {
        return { ...prompt, active: true };
      } else {
        return { ...prompt, active: false };
      }
    });
  };
  const editPrompt = () => {
    onSelecetdPrompt(data);
    onOpenPromptDialogForEdit(true);
  };

  const handleChange = (event) => {
    const updatedPromptData = updatePromptData(promptData, event.target.value);
    onSetPromptdata(updatedPromptData);
  };

  const updatePromptData = (promptData, value) => {
    return promptData.map((data) => {
      if (data.scope == scopeType.RECRUITER_QUESTION) {
        data.numberOfQuestion = value;
      } else if (data.scope == scopeType.CANDIDATE_SUMMARY) {
        data.numberOfWords = value;
      }
      return data;
    });
  };
  return (
    <Grid item xs={12} key={index}>
      <Grid container sx={{ width: '100%', marginLeft: 4, marginTop: 2 }}>
        <Box pt={0.1} display="flex" alignItems="center" sx={{ width: '20%', gap: 3 }}>
          <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.BLACK} bold={true}>
            {data.promptTitle}
          </WsTypography>
          {data.default && <WsLogo />}
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            width: '73%',
          }}
        >
          {data?.active ? <WsActiveIconAndText /> : <WsDisableIconAndText />}

          <WsElementWithPopOver element={<WsIconMoreVer />}>
            <Box p={1}>
              <WsTypography
                variant={WsTypoVariants.SUB_TITLE}
                cursor="pointer"
                onClick={onActivatePrompt}
                color={WsTypoColors.TERTIARY900}
              >
                <CheckCircleOutlinedIcon
                  style={{
                    marginRight: 1,
                    verticalAlign: 'bottom',
                    color: '#484D6D',
                  }}
                />
                Activate Prompt
              </WsTypography>
            </Box>
            {!data.default && (
              <Box p={1}>
                <WsTypography
                  variant={WsTypoVariants.SUB_TITLE}
                  cursor="pointer"
                  onClick={editPrompt}
                  color={WsTypoColors.TERTIARY900}
                >
                  <ModeEditOutlineOutlinedIcon
                    style={{
                      marginRight: 1,
                      verticalAlign: 'bottom',
                      color: '#484D6D',
                    }}
                  />
                  Edit Prompt
                </WsTypography>
              </Box>
            )}
          </WsElementWithPopOver>
        </Box>
      </Grid>
      {data.default ? (
        <Grid container sx={{ width: '100%', marginLeft: 4, marginTop: 2.5 }}>
          <Box pt={0.1} display="flex" alignItems="center">
            <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.BLACK} cursor="text">
              {defaultTitleHeading[data.scope]}
            </WsTypography>

            <TextField
              type="number"
              value={defaultNumber}
              onChange={handleChange}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ width: 90, marginLeft: 3.6 }}
              size="small"
              inputProps={{
                step: 1,
                min: 0,
              }}
            />
          </Box>
        </Grid>
      ) : (
        <Grid container sx={{ width: '100%', marginLeft: 4, marginTop: 2.5 }}>
          <Box pt={0.1} display="flex" alignItems="center">
            <TextField
              type="text"
              value={data.prompt}
              disabled={true}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                width: 800,
                backgroundColor: '#EAEAF1',
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: '#11151C',
                },
              }}
              size="medium"
              multiline
              maxRows={6}
            />
          </Box>
        </Grid>
      )}
      {index !== promptData.length - 1 && <Divider style={{ marginTop: 20, marginBottom: 10 }} />}
    </Grid>
  );
};

export default PromptList;
